import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AuthLayout from "../components/AuthLayout";
import LoginForm from "../components/LoginForm";
import { useAuth } from "../hooks/useAuth";

// Main signin page component
const SigninPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { login, loginWithGoogle, loading, error, clearError, uid } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Check for verification success message in URL params
  const [verificationSuccess, setVerificationSuccess] = useState(false);

  useEffect(() => {
    // Check if user was redirected after successful verification
    const params = new URLSearchParams(location.search);
    if (params.get("verified") === "true") {
      setVerificationSuccess(true);
      // Clear the URL parameter after reading it
      navigate("/signin", { replace: true });
      // Clear any previous auth errors
      clearError();
    }
  }, [location, navigate, clearError]);

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    await login(email, password);
  };

  // Handle Google sign in
  const handleGoogleSignIn = async (e) => {
    e.preventDefault();
    await loginWithGoogle();
  };

  // Handle redirect to verification page
  const handleVerificationRedirect = () => {
    if (uid) {
      navigate(`/verify-email?uid=${uid}`);
    } else {
      navigate("/verify-email");
    }
  };

  return (
    <AuthLayout>
      {verificationSuccess && (
        <div className="mb-4 max-w-md mx-auto">
          <div className="bg-green-50 border-l-4 border-green-400 p-4">
            <div className="flex">
              <div className="flex-shrink-0">
                <svg
                  className="h-5 w-5 text-green-400"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
              <div className="ml-3">
                <p className="text-sm text-green-700">
                  Your email has been verified successfully. You can now sign
                  in.
                </p>
              </div>
            </div>
          </div>
        </div>
      )}

      <LoginForm
        email={email}
        setEmail={setEmail}
        password={password}
        setPassword={setPassword}
        onSubmit={handleSubmit}
        onGoogleSignIn={handleGoogleSignIn}
        loading={loading}
        error={error}
        needsVerification={error && error.includes("verification")}
        handleVerificationRedirect={handleVerificationRedirect}
      />
    </AuthLayout>
  );
};

export default SigninPage;
